import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { MessageService } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import { FacturaService } from 'src/app/services/factura.service';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { Usuario } from 'src/app/models/usuario-sesion.interface';
import { Catalogo } from 'src/app/models/catalogo.interface';
import { FacturaProductos } from 'src/app/models/factura-productos.interface';
import { TipoProducto } from 'src/app/models/tipo-producto.interface';
import * as moment from 'moment';

@Component({
  selector: 'app-factura-form',
  templateUrl: './factura-form.component.html',
  styleUrls: ['./factura-form.component.scss'],
  standalone: false, // ↳ ponlo en true si usas componentes standalone
  providers: [MessageService]
})
export class FacturaFormComponent implements OnInit {
  facturaForm: FormGroup;
  // en tu componente:
  initialData = {
    numero_factura: null,
    fecha: null,
    fk_usuario: null,
    productos: []  // o bien tu lista inicial si vienes de un “editar”
  };

  // Opciones de ejemplo; reemplaza por tus datos reales
  usuarios: Catalogo[] = [];
  tiposProductos: Catalogo[] = [];

  get productos(): FormArray {
    return this.facturaForm.get('productos') as FormArray;
  }
  constructor(private fb: FormBuilder, private facturaService: FacturaService, private auth: AuthService, private router: Router, private catalogo: CatalogoService, private messageService: MessageService) {
    this.facturaForm = this.crearFormuario();
  }

  ngOnInit(): void {
    this.loadCatalogos();
  }

  loadCatalogos(): void {
    forkJoin({
      subEmpresas: this.catalogo.empresas(),
      subTiposProductos: this.catalogo.tipos_productos(),
    }).subscribe({
      next: (resp) => {
        this.fillEmpresas(resp.subEmpresas.datos);
        this.fullTiposProductos(resp.subTiposProductos.datos);
      },
      error: (err) => console.error(err)
    });
  }

  fillEmpresas(items: Usuario[]): void {
    this.usuarios.push(...items.map((item) => <Catalogo>{ label: item.nombre, value: item.id }));
  }
  fullTiposProductos(items: TipoProducto[]) {
    this.tiposProductos.push(...items.map((item) => <Catalogo>{ label: item.descripcion, value: item.id }));
  }
  crearFormuario(): FormGroup {
    return this.fb.group({
      numero_factura: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9\-]+$/),   // solo letras-números y guiones
          Validators.maxLength(20)
        ]
      ],
      fecha: [
        '',
        [
          Validators.required
        ]
      ],
      fk_usuario: [null, Validators.required],
      productos: this.fb.array([], [Validators.required, Validators.minLength(1)]),
    });
  }

  crearProducto(): FormGroup {
    return this.fb.group({
      fk_tipo_producto: ['', Validators.required],
      lote: ['', Validators.required],
      cantidad_productos: [null, [Validators.required, Validators.min(1)]]
    });
  }

  addProducto(): void {
    this.productos.push(this.crearProducto());
  }

  removeProducto(i: number) {
    this.productos.removeAt(i);
  }
  /** Atajo para acceder a un control en la plantilla */
  getControl(name: string): AbstractControl {
    return this.facturaForm.get(name)!;
  }

  onSubmit(): void {
    this.facturaForm.getRawValue()
    console.log(this.facturaForm.getRawValue())
    if (this.facturaForm.invalid) {
      this.facturaForm.markAllAsTouched();
      return;
    }
    // Aquí va tu lógica de envío (p. ej. servicio HTTP)
    //console.log(this.facturaForm.value);

    let factura_productos: FacturaProductos = this.facturaForm.getRawValue();
    const rawDate: Date = this.facturaForm.get('fecha')?.value;
    const formatted = moment(rawDate).format('YYYY-MM-DD');
    factura_productos.fecha = formatted;
    this.facturaService
      .createFacturaProductos(factura_productos)
      .subscribe({
        next: (resp) => {
          this.showSuccess(resp.mensaje);
          //this.router.navigate(['/producto']);
          //console.log(resp.datos);
          this.resetForm();
        },
        error: (err) => {
          console.error(err.error.message);
        }
      })

  }
  resetForm(): void {
    // 1) Limpia el FormArray totalmente
    const productosArray = this.facturaForm.get('productos') as FormArray;
    while (productosArray.length) {
      productosArray.removeAt(0);
    }

    // 2) Resetea el FormGroup con los valores iniciales
    this.facturaForm.reset(this.initialData);
    /* 3) Si quieres volver a poblar productos con un “initialData.productos”:
      this.initialData.productos.forEach(p =>
        productosArray.push(this.crearProducto(p))
      );
    */
    // 4) Opcional: deja el formulario como pristine/untouched
    this.facturaForm.markAsPristine();
    this.facturaForm.markAsUntouched();

  }
  salir(): void {
    this.router.navigate(["/productos-facturados"]);
  }
  showSuccess(msg: string): void {
    this.messageService.add({ severity: 'success', summary: 'Éxito', detail: msg });
  }
  showWarning(msg: string): void {
    this.messageService.add({ severity: 'warn', summary: 'Nota!!', detail: msg });
  }
}
